import React from 'react';
import {Card} from '../Card';
import {Text} from '../Text';
import {Button} from '../Button';
import { useAuth, useCampaign } from 'api';
import { lightBlue, green } from 'config/colors';


export function PageCardLarge(props) {
  
  const auth = useAuth();
  const companyId = auth && auth.user.companyId;
  const campaign = useCampaign(companyId, props.campaignId);
  
  return (
    <Card style={{padding:0, marginBottom:16, ...props.style}}>
      <Button tertiary to={props.onClick ? null : `/pages/${props.id}`} style={{display:'flex', flexDirection:'column', alignItems:'center'}} onClick={props.onClick}>
        <div 
          style={{
            width: "calc(100% - 32px)",
            height: 300,
            margin: "16px 0",
            backgroundImage: props.preview ? `url(${props.preview})` : 'none',
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
          }}
        />
        <Text block semibold color={lightBlue} style={{marginBottom:4}}>{props.name}</Text>
        <Text block small color={green} style={{marginBottom:12}}>
          {campaign && campaign.name}
        </Text>
      </Button>
    </Card>
  );  
}